import { PageTransition } from '../PageTransition';
import { MassMessagesPage } from './compact/MassMessagesPage';

interface MassMessagesTabProps {
  accountId: string;
  platform?: 'onlyfans' | 'fansly';
}

/** Mass Messages — compact layout: Setup (campaigns + message lists) and Schedule. */
export function MassMessagesTab({ accountId, platform = 'onlyfans' }: MassMessagesTabProps) {
  return (
    <PageTransition>
      <MassMessagesPage key={accountId} kind="mass" accountId={accountId} platform={platform} />
    </PageTransition>
  );
}
